import React from 'react';
import PropTypes from 'prop-types';
import triggerChatFlow from '~src/utils/triggerChatFlow';

const ProductCard = ({ name, orgName, imageUrl }) => {
  const onRequestInfo = (e) => {
    e?.stopPropagation?.();
    const prefill = `Salve, sono interessato a: ${name}`;
    triggerChatFlow(prefill);
  };

  return (
    <div className="product-card g-card" role="group">
      <div className="product-card__image">
        <img
          src={imageUrl || '/assets/svg/immagine.svg'}
          alt={name}
          loading="lazy"
        />
        <div className="product-card__hover" aria-hidden="true">
          <button
            type="button"
            className="product-card__pill"
            onClick={onRequestInfo}
            aria-label="Richiedi informazioni in chat"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm0 12H5.17L4 15.17V4h16v10Z"
              />
            </svg>
            <span className="product-card__pill-text">
              Richiedi informazioni
            </span>
          </button>
        </div>
      </div>
      <div className="product-card__meta">
        <div className="product-card__title">{name}</div>
        {orgName ? (
          <div className="product-card__subtitle">{orgName}</div>
        ) : null}
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  name: PropTypes.string.isRequired,
  orgName: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default ProductCard;
